/* TNF Quick Buy Modal additions (live + draft).
   Injects same-day shipping countdown (sticky below ATC) + product stars
   from the clicked card into the Quick Buy modal when it opens.
*/
(function () {
  if (window._tnfQbmShippingInited) return;
  window._tnfQbmShippingInited = true;

  // 2026-05-19 v2 — Diana: "i dont want this view cart button in qb modal
  // theres an issue where when i open the cart on wishlist page then none of
  // the move to cart buttons work after that." → REMOVE the View-cart
  // cart-status injection AND the force-stay-open submit-intercept globally
  // (was previously only skipped on /pages/buy-again). QB modal now behaves
  // like Shopify's default: variant-bundle-common.js handles add-to-cart,
  // tnf-cart-no-auto-open.js handles the cart drawer.

  var CSS = ''
    + '.tnf-qbm-countdown { position: sticky; bottom: 0; z-index: 10; padding: 12px 14px; margin: 12px 0 0; font-family: Barlow, system-ui, sans-serif; font-size: 13px; font-weight: 700; text-align: center; line-height: 1.2; background: #e6f7ee; color: #0a6e2c; border-radius: 8px; box-shadow: 0 -4px 12px rgba(0,0,0,0.08); letter-spacing: 0.2px; }'
    + '.tnf-qbm-countdown.is-after-cutoff { background: #ffefef; color: #b81c20; box-shadow: 0 -4px 12px rgba(184,28,32,0.12); }'
    + '#variant-quick-buy-modal-body { overflow-y: auto !important; }'
    + '.tnf-qbm-stars { display: inline-flex; align-items: center; gap: 6px; font-family: Barlow, system-ui, sans-serif; font-size: 12.5px; line-height: 1; color: #677279; margin: 6px 0 0; }'
    + '.tnf-qbm-stars-row { position: relative; display: inline-block; font-size: 14px; line-height: 1; letter-spacing: 0.5px; color: #ffc107; }'
    + '.tnf-qbm-stars-bg { color: #e0e6ec; }'
    + '.tnf-qbm-stars-fg { position: absolute; left: 0; top: 0; overflow: hidden; white-space: nowrap; color: #ffc107; }'
    + '.tnf-qbm-stars-num { font-weight: 700; color: #1e2d7d; }'
    + '.tnf-qbm-stars-count { color: #95a0aa; font-size: 11.5px; }'
    // 2026-05-19 — cart-status block + View-cart link CSS removed (was breaking
    // subsequent Move-to-cart taps on the wishlist page when the View-cart link
    // was clicked from inside the QB modal).
    // 2026-05-12 — On mobile the QB modal used to cover the header. Push the modal
    // down so the header (and the flashing cart icon) stays visible while the modal
    // is open. Estimated header height ~58px Warehouse default, +30px for the Onward
    // strip when present — give it 90px breathing room. Body scrolls inside the modal.
    + '@media (max-width: 767px) {'
    + '  #variant-quick-buy-modal-overlay { top: 90px !important; height: calc(100% - 90px) !important; }'
    + '  #variant-quick-buy-modal { max-height: calc(100vh - 90px) !important; }'
    + '  #variant-quick-buy-modal-overlay .modal-overlay__inner { padding-top: 0 !important; }'
    + '}';
  var style = document.createElement('style');
  style.id = 'tnf-qbm-shipping-style';
  style.textContent = CSS;
  document.head.appendChild(style);

  function tickQbm() {
    try {
      var fmt = new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Toronto', hour: '2-digit', minute: '2-digit', hour12: false, weekday: 'short' });
      var parts = fmt.formatToParts(new Date());
      var hour = parseInt(parts.find(function (p) { return p.type === 'hour'; }).value, 10);
      var min = parseInt(parts.find(function (p) { return p.type === 'minute'; }).value, 10);
      var weekday = parts.find(function (p) { return p.type === 'weekday'; }).value;
      var isWeekend = (weekday === 'Sat' || weekday === 'Sun');
      var msg, after = false;
      if (isWeekend || hour >= 16) {
        msg = '🔥 Popular — order now, ships next business day';
        after = true;
      } else {
        var minsLeft = (16 - hour) * 60 - min;
        var hLeft = Math.floor(minsLeft / 60);
        var mLeft = minsLeft % 60;
        var stamp = hLeft > 0 ? (hLeft + 'h ' + mLeft + 'm') : (mLeft + 'm');
        msg = '⚡ Order in ' + stamp + ' for same-day shipping';
      }
      document.querySelectorAll('.tnf-qbm-countdown').forEach(function (el) {
        el.textContent = msg;
        el.classList.toggle('is-after-cutoff', after);
      });
    } catch (e) {}
  }

  // Track which product card was clicked so we can copy its rating into the modal
  var _lastClickedCard = null;
  document.addEventListener('click', function (e) {
    var card = e.target.closest('.product-item[data-tnf-rating]');
    if (card) _lastClickedCard = card;
  }, true);

  function ensureQbmStars() {
    var modalBody = document.getElementById('variant-quick-buy-modal-body');
    if (!modalBody) return;
    if (modalBody.querySelector('.tnf-qbm-stars')) return;
    var rating = _lastClickedCard && _lastClickedCard.getAttribute('data-tnf-rating');
    var count = _lastClickedCard && _lastClickedCard.getAttribute('data-tnf-rating-count');
    if (!rating || !count) return;
    var avg = parseFloat(rating);
    if (isNaN(avg) || avg <= 0) return;
    var pct = avg * 20;
    var titleEl = modalBody.querySelector('.vqb-product-title') || document.getElementById('variant-quick-buy-modal-title');
    var stars = document.createElement('div');
    stars.className = 'tnf-qbm-stars';
    stars.innerHTML =
      '<span class="tnf-qbm-stars-row" aria-hidden="true">' +
        '<span class="tnf-qbm-stars-bg">★★★★★</span>' +
        '<span class="tnf-qbm-stars-fg" style="width:' + pct + '%">★★★★★</span>' +
      '</span>' +
      '<span class="tnf-qbm-stars-num">' + avg.toFixed(1) + '</span>' +
      '<span class="tnf-qbm-stars-count">(' + count + ' review' + (count == 1 ? '' : 's') + ')</span>';
    if (titleEl && titleEl.parentNode) {
      // Insert right after the title
      titleEl.parentNode.insertBefore(stars, titleEl.nextSibling);
    } else {
      modalBody.insertBefore(stars, modalBody.firstChild);
    }
  }

  function ensureQbmShipping() {
    var modalBody = document.getElementById('variant-quick-buy-modal-body');
    if (!modalBody) return;
    // Inject stars right after the product title (idempotent)
    ensureQbmStars();
    if (modalBody.querySelector('.tnf-qbm-countdown')) return;
    var line = document.createElement('div');
    line.className = 'tnf-qbm-countdown';
    line.textContent = '⚡ Same-day shipping by 4 PM EST';

    // Append as the LAST DIRECT CHILD of modal-body so position: sticky pins it
    // to the bottom of the modal-body's scroll container (not just inside the
    // form-buttons row). Inserting deeper would constrain sticky to that
    // ancestor's bounding box and the countdown would scroll off with the form.
    modalBody.appendChild(line);
    tickQbm();
  }

  // 2026-05-19 v2 — Cart-status injection (View cart link + per-product cart
  // breakdown) REMOVED. Was breaking subsequent Move-to-cart taps on the
  // wishlist page after the View-cart link was clicked, because the synthetic
  // header-cart click + the force-stay-open MutationObserver lock left the QB
  // modal in a stale state. QB modal now passes the form through to the
  // theme's native handler — cart drawer opens via tnf-cart-no-auto-open.js's
  // whitelisted /cart/add event.

  function watchQbmOpen() {
    var overlay = document.getElementById('variant-quick-buy-modal-overlay');
    if (!overlay) return false;
    function check() {
      if (overlay.classList.contains('is-open')) {
        setTimeout(function () { ensureQbmShipping(); }, 30);
      }
    }
    check();
    new MutationObserver(check).observe(overlay, { attributes: true, attributeFilter: ['class'] });
    var body = document.getElementById('variant-quick-buy-modal-body');
    if (body) {
      new MutationObserver(function () {
        if (overlay.classList.contains('is-open')) { ensureQbmShipping(); }
      }).observe(body, { childList: true });
    }
    return true;
  }

  var attempts = 0;
  var iv = setInterval(function () {
    if (watchQbmOpen()) clearInterval(iv);
    if (++attempts > 60) clearInterval(iv);
  }, 500);

  setInterval(tickQbm, 30000);
})();
